(function () {
  function balanceTabRows(nav, buttonSelector, balancedClass) {
    const buttons = Array.from(nav.querySelectorAll(buttonSelector));
    if (!buttons.length) return;

    const style = getComputedStyle(nav);
    const gap = parseFloat(style.columnGap || style.gap) || 10;
    const available =
      nav.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

    buttons.forEach((button) => {
      button.style.flex = 'none';
      button.style.maxWidth = 'none';
    });

    const minBtn = Math.max(...buttons.map((button) => button.offsetWidth));

    buttons.forEach((button) => {
      button.style.flex = '';
      button.style.maxWidth = '';
    });

    const count = buttons.length;
    let bestCols = 1;
    let bestScore = Infinity;

    for (let cols = 1; cols <= count; cols += 1) {
      const needed = cols * minBtn + (cols - 1) * gap;
      if (needed > available + 1) continue;

      const lastRow = count % cols || cols;
      const imbalance = cols - lastRow;
      const rows = Math.ceil(count / cols);
      const score = imbalance * 100 + rows + (cols === 1 && count > 2 ? 1000 : 0);

      if (score < bestScore) {
        bestScore = score;
        bestCols = cols;
      }
    }

    nav.style.setProperty('--sp-tab-cols', String(bestCols));
    nav.style.setProperty('--sp-tab-gap', `${gap}px`);
    nav.classList.add(balancedClass);
  }

  function initBalancedTabs() {
    const configs = [
      {
        selector: '[data-sp-catalog-tabs], [data-sp-coleccion-tabs]',
        buttonSelector: '.sp-catalog-tabs__btn',
        balancedClass: 'sp-catalog-tabs--balanced',
      },
      {
        selector: '[data-sp-home-collection-tabs]',
        buttonSelector: '.sp-home-collections__btn',
        balancedClass: 'sp-home-collections__buttons--balanced',
      },
    ];

    configs.forEach(({ selector, buttonSelector, balancedClass }) => {
      document.querySelectorAll(selector).forEach((nav) => {
        balanceTabRows(nav, buttonSelector, balancedClass);

        if (typeof ResizeObserver !== 'undefined') {
          const observer = new ResizeObserver(() => balanceTabRows(nav, buttonSelector, balancedClass));
          observer.observe(nav);
          return;
        }

        window.addEventListener('resize', () => balanceTabRows(nav, buttonSelector, balancedClass));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBalancedTabs);
  } else {
    initBalancedTabs();
  }
})();
